import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import { SITE_URL } from '@/constants';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeatureGrid from './components/FeatureGrid';
import AboutSEOSection from './components/AboutSEOSection';
import HowItWorksSection from './components/HowItWorksSection';
import ComparisonSection from './components/ComparisonSection';
import SafetySection from './components/SafetySection';
import FeaturedSnippetSection from './components/FeaturedSnippetSection';
import TestimonialsSection from './components/TestimonialsSection';
import FinalCTASection from './components/FinalCTASection';
import SEOArticlesGrid from './components/SEOArticlesGrid';
import { categories } from '@/mocks/categories';

const categoryGridAImages = [
  'https://readdy.ai/api/search-image?query=Pair%20of%20elegant%20leather%20sneakers%20placed%20on%20a%20textured%20concrete%20surface%20with%20dramatic%20side%20lighting%20casting%20long%20artistic%20shadows%2C%20editorial%20fashion%20photography%2C%20minimalist%20urban%20aesthetic%2C%20warm%20terracotta%20and%20sand%20tones%2C%20high%20contrast%20composition%2C%20visible%20material%20texture%20and%20stitching%20details&width=800&height=600&seq=cat-shoes-v2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Oversized%20chunky%20knit%20sweater%20in%20oatmeal%20tone%20draped%20over%20a%20vintage%20wooden%20chair%20near%20a%20sunlit%20window%2C%20soft%20golden%20hour%20light%20streaming%20through%20sheer%20curtains%2C%20lifestyle%20fashion%20photography%2C%20cozy%20warm%20atmosphere%2C%20cream%20and%20caramel%20tones%2C%20editorial%20Scandinavian%20interior%20style%20with%20visible%20knit%20texture&width=800&height=600&seq=cat-hoodies-v2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Premium%20heavyweight%20cotton%20t-shirt%20in%20sage%20green%20casually%20tossed%20on%20rumpled%20white%20linen%20bedsheet%20with%20morning%20sunlight%2C%20relaxed%20lifestyle%20product%20photography%2C%20organic%20natural%20aesthetic%2C%20soft%20botanical%20tones%2C%20editorial%20casual%20fashion%2C%20visible%20fabric%20grain%20and%20drape%20movement&width=800&height=600&seq=cat-tshirts-v2&orientation=landscape',
];

const topPicksImages = [
  'https://readdy.ai/api/search-image?query=Classic%20denim%20trucker%20jacket%20hanging%20on%20a%20rustic%20metal%20hook%20against%20an%20exposed%20brick%20wall%20with%20warm%20afternoon%20light%2C%20editorial%20street%20style%20photography%2C%20industrial%20loft%20aesthetic%2C%20rich%20indigo%20and%20rust%20tones%2C%20visible%20worn%20texture%20and%20copper%20hardware%20details&width=800&height=800&seq=cat-jackets-v2&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Tailored%20wide-leg%20trousers%20in%20charcoal%20grey%20laid%20flat%20on%20polished%20dark%20hardwood%20flooring%20with%20dramatic%20side%20lighting%2C%20high%20fashion%20editorial%20photography%2C%20sophisticated%20urban%20aesthetic%2C%20metallic%20graphite%20tones%2C%20sharp%20crease%20detail%20and%20luxurious%20fabric%20drape&width=800&height=800&seq=cat-pants-v2&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Vintage%20washed%20baseball%20cap%20in%20faded%20olive%20resting%20on%20a%20stack%20of%20art%20books%20on%20a%20midcentury%20modern%20desk%2C%20warm%20desk%20lamp%20illumination%2C%20creative%20studio%20aesthetic%2C%20earthy%20olive%20and%20parchment%20tones%2C%20editorial%20still%20life%20photography%20with%20intellectual%20mood&width=800&height=800&seq=cat-headwear-v2&orientation=squarish',
];

const categoryGridBImages = [
  'https://readdy.ai/api/search-image?query=Coordinated%20two-piece%20linen%20set%20in%20soft%20clay%20pink%20color%20displayed%20on%20a%20rattan%20chair%20in%20a%20sunlit%20tropical%20veranda%2C%20resort%20fashion%20photography%2C%20natural%20woven%20textures%2C%20blush%20and%20sand%20tones%2C%20lush%20green%20foliage%20visible%20through%20open%20doors%2C%20editorial%20vacation%20lifestyle%20aesthetic&width=800&height=600&seq=cat-sets-v2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Luxurious%20organic%20cotton%20basics%20in%20muted%20earth%20tones%20neatly%20arranged%20on%20a%20marble%20bathroom%20countertop%20with%20spa-like%20ambiance%2C%20soft%20diffused%20backlighting%2C%20premium%20wellness%20aesthetic%2C%20warm%20stone%20and%20linen%20tones%2C%20editorial%20self-care%20photography%20with%20eucalyptus%20sprig%20accent&width=800&height=600&seq=cat-underwear-v2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Performance%20athletic%20jersey%20in%20deep%20forest%20green%20with%20moisture-wicking%20texture%20draped%20over%20gym%20equipment%20with%20natural%20gym%20lighting%2C%20sportswear%20editorial%20photography%2C%20modern%20fitness%20aesthetic%2C%20emerald%20and%20charcoal%20tones%2C%20dynamic%20fabric%20movement%20captured%20mid-air&width=800&height=600&seq=cat-jersey-v2&orientation=landscape',
];

const deepGuidesImages = [
  'https://readdy.ai/api/search-image?query=Clean%20organized%20desk%20workspace%20with%20MacBook%20displaying%20colorful%20spreadsheet%20charts%20and%20graphs%2C%20mechanical%20keyboard%2C%20ceramic%20coffee%20mug%20with%20latte%20art%2C%20natural%20daylight%20from%20large%20window%2C%20modern%20home%20office%20aesthetic%2C%20warm%20oak%20and%20slate%20tones%2C%20professional%20productivity%20photography&width=800&height=800&seq=guide-how-v2&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Two%20monitors%20side%20by%20side%20on%20a%20dark%20walnut%20desk%20showing%20comparison%20analytics%20dashboards%2C%20modern%20office%20setup%20with%20geometric%20desk%20lamp%20and%20succulents%2C%20cool%20daylight%20balanced%20with%20warm%20LED%20glow%2C%20tech%20professional%20aesthetic%2C%20charcoal%20and%20copper%20tones&width=800&height=800&seq=guide-compare-v2&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Minimalist%20desk%20with%20iPhone%20displaying%20a%20security%20authentication%20screen%20next%20to%20a%20leather%20notebook%20and%20fountain%20pen%2C%20soft%20natural%20window%20light%20with%20privacy%20blinds%20partially%20drawn%2C%20cybersecurity%20lifestyle%20photography%2C%20warm%20grey%20and%20ivory%20tones%2C%20sense%20of%20digital%20protection%20and%20trust&width=800&height=800&seq=guide-safety-v2&orientation=squarish',
];

const seoArticles = [
  {
    title: 'What Exactly Is OOPBuy Spreadsheet — A Detailed Breakdown',
    excerpt: 'Understand the core concept behind the spreadsheet shopping system, how it evolved, and why it is gaining traction among online shoppers worldwide.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Open%20laptop%20on%20a%20clean%20white%20desk%20displaying%20a%20detailed%20spreadsheet%20interface%20with%20product%20listings%2C%20warm%20morning%20sunlight%20streaming%20through%20blinds%2C%20modern%20minimalist%20home%20office%2C%20organized%20workspace%20with%20notebooks%20and%20coffee%2C%20professional%20productivity%20aesthetic%2C%20soft%20beige%20and%20cream%20tones&width=800&height=600&seq=seo-art-01&orientation=landscape',
    linkTo: '/oopbuy-spreadsheet-guide',
    category: 'Beginner',
    readTime: '8 min read',
  },
  {
    title: 'How the Spreadsheet Shopping Workflow Actually Functions',
    excerpt: 'A step-by-step walkthrough of the complete OOPBuy workflow, from initial product browsing to final order tracking and everything in between.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Person%20pointing%20at%20a%20tablet%20screen%20showing%20a%20structured%20workflow%20diagram%20with%20connected%20steps%2C%20bright%20modern%20co-working%20space%20background%20with%20plants%20and%20natural%20light%2C%20tech%20tutorial%20aesthetic%2C%20coral%20and%20ivory%20tones%2C%20hands-on%20demonstration%20photography&width=800&height=600&seq=seo-art-02&orientation=landscape',
    linkTo: '/oopbuy-spreadsheet-guide',
    category: 'How-To',
    readTime: '10 min read',
  },
  {
    title: 'OOPBuy Spreadsheet vs Traditional Shopping — The Full Comparison',
    excerpt: 'See exactly how the spreadsheet system stacks up against conventional online shopping across organization, transparency, and efficiency metrics.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Split%20screen%20comparison%20visual%20on%20a%20large%20desktop%20monitor%2C%20left%20side%20shows%20cluttered%20browser%20tabs%20right%20side%20shows%20clean%20organized%20spreadsheet%2C%20modern%20office%20desk%20setting%2C%20cool%20daylight%20balanced%20with%20screen%20glow%2C%20contrast%20comparison%20photography&width=800&height=600&seq=seo-art-03&orientation=landscape',
    linkTo: '/oopbuy-spreadsheet-guide',
    category: 'Comparison',
    readTime: '12 min read',
  },
  {
    title: 'Essential Safety Tips Every OOPBuy Spreadsheet User Should Know',
    excerpt: 'Learn the critical safety practices, verification steps, and security considerations that protect your shopping experience from start to finish.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Close%20up%20of%20hands%20typing%20on%20a%20laptop%20keyboard%20with%20a%20shield%20lock%20icon%20glowing%20on%20the%20screen%2C%20dark%20moody%20home%20office%20lighting%20with%20warm%20amber%20desk%20lamp%2C%20cybersecurity%20theme%20photography%2C%20charcoal%20and%20gold%20tones%2C%20sense%20of%20digital%20protection%20and%20vigilance&width=800&height=600&seq=seo-art-04&orientation=landscape',
    linkTo: '/oopbuy-spreadsheet-guide',
    category: 'Safety',
    readTime: '9 min read',
  },
  {
    title: 'Pro Tips for First-Time Spreadsheet Shoppers',
    excerpt: 'Jumpstart your OOPBuy journey with practical strategies, smart scanning techniques, and insider advice from experienced spreadsheet shoppers.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Young%20professional%20woman%20smiling%20while%20working%20on%20a%20laptop%20at%20a%20bright%20cafe%20table%2C%20notebook%20with%20handwritten%20tips%20visible%2C%20warm%20ambient%20coffee%20shop%20lighting%2C%20lifestyle%20learning%20photography%2C%20caramel%20and%20cream%20tones%2C%20approachable%20friendly%20atmosphere&width=800&height=600&seq=seo-art-05&orientation=landscape',
    linkTo: '/oopbuy-spreadsheet-buying-guide',
    category: 'Tips',
    readTime: '7 min read',
  },
  {
    title: 'Smart Comparison Strategies That Save You Hours',
    excerpt: 'Master the three-column scan technique, set effective filters, and learn cross-category comparison methods that the pros use daily.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20a%20desk%20with%20two%20smartphones%20and%20a%20tablet%20all%20displaying%20comparison%20charts%20and%20data%20grids%2C%20marble%20desk%20surface%20with%20geometric%20accessories%2C%20organized%20productivity%20aesthetic%2C%20slate%20and%20rose%20gold%20tones%2C%20top-down%20editorial%20photography&width=800&height=600&seq=seo-art-06&orientation=landscape',
    linkTo: '/oopbuy-spreadsheet-buying-guide',
    category: 'Strategy',
    readTime: '11 min read',
  },
  {
    title: 'Common Spreadsheet Shopping Mistakes and How to Avoid Them',
    excerpt: 'Identify the four most frequent pitfalls that trip up even experienced shoppers and learn exactly how to sidestep them.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Person%20thoughtfully%20reviewing%20a%20laptop%20screen%20with%20a%20slightly%20furrowed%20brow%2C%20sticky%20notes%20with%20corrections%20placed%20around%20the%20monitor%2C%20warm%20home%20office%20lighting%20with%20soft%20shadows%2C%20problem-solving%20editorial%20photography%2C%20muted%20terracotta%20and%20beige%20tones&width=800&height=600&seq=seo-art-07&orientation=landscape',
    linkTo: '/oopbuy-spreadsheet-buying-guide',
    category: 'Guide',
    readTime: '8 min read',
  },
  {
    title: 'Advanced Spreadsheet Techniques for Power Users',
    excerpt: 'Take your skills to the next level with batch processing, supplier pattern recognition, and seasonal timing strategies.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20workspace%20with%20dual%20monitors%20showing%20complex%20data%20dashboards%2C%20mechanical%20keyboard%20with%20RGB%20lighting%2C%20dark%20mode%20interface%20aesthetic%2C%20modern%20tech%20office%20at%20dusk%2C%20navy%20and%20amber%20tones%2C%20power%20user%20productivity%20photography&width=800&height=600&seq=seo-art-08&orientation=landscape',
    linkTo: '/oopbuy-spreadsheet-buying-guide',
    category: 'Advanced',
    readTime: '10 min read',
  },
  {
    title: 'Your Complete OOPBuy Shopping Action Plan for 2026',
    excerpt: 'A practical six-step plan that synthesizes everything into a repeatable workflow you can follow every time you shop.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20whiteboard%20with%20a%20structured%20action%20plan%20written%20in%20neat%20handwriting%2C%20modern%20office%20meeting%20room%20with%20natural%20daylight%20and%20indoor%20plants%2C%20planning%20and%20strategy%20aesthetic%2C%20crisp%20white%20and%20sage%20green%20tones%2C%20organized%20goal-setting%20photography&width=800&height=600&seq=seo-art-09&orientation=landscape',
    linkTo: '/oopbuy-spreadsheet-buying-guide',
    category: 'Plan',
    readTime: '6 min read',
  },
];

export default function Home() {
  const siteUrl = SITE_URL;

  const homeSchema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        name: 'OOPBuy Spreadsheet Guide',
        url: siteUrl,
        description: 'Learn everything about OOPBuy Spreadsheet in 2026. Step-by-step guide, honest reviews, safety explanation, and comparison with other spreadsheet buying systems.',
        inLanguage: 'en-US',
      },
      {
        '@type': 'FAQPage',
        name: 'OOPBuy Spreadsheet Frequently Asked Questions',
        url: siteUrl,
        mainEntity: [
          {
            '@type': 'Question',
            name: 'What is OOPBuy Spreadsheet?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'OOPBuy Spreadsheet is a structured online system that helps users compare, organize, and manage product purchases using spreadsheet-style data, making shopping more efficient and transparent. It combines product comparison tools with a centralized buying agent system.',
            },
          },
          {
            '@type': 'Question',
            name: 'How does OOPBuy Spreadsheet work?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Users browse structured product spreadsheets, analyze product data including price and supplier details, compare multiple listings in one view, select preferred items, follow a guided purchase process, and track order status within the system.',
            },
          },
          {
            '@type': 'Question',
            name: 'Is OOPBuy Spreadsheet safe to use?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'OOPBuy Spreadsheet is an informational and organizational system that does not process payments or store financial credentials. Safety depends on verifying external sellers, using trusted payment methods, and double-checking product information before purchase.',
            },
          },
          {
            '@type': 'Question',
            name: 'How does OOPBuy Spreadsheet compare to traditional shopping?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Compared to traditional shopping, OOPBuy Spreadsheet offers advanced spreadsheet-based product organization, real-time structured price comparison, higher transparency with all data visible, integrated end-to-end order tracking, and a unified interface for all product data.',
            },
          },
          {
            '@type': 'Question',
            name: 'What are the benefits of using OOPBuy Spreadsheet?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Key benefits include faster decision making through structured layouts, better comparison accuracy with side-by-side data, cost transparency with clear pricing, centralized management of all product information, beginner-friendly spreadsheet interface, and global access to multiple international sellers.',
            },
          },
        ],
      },
      {
        '@type': 'WebPage',
        name: 'OOPBuy Spreadsheet Guide 2026 | Reviews, Tutorial, Comparison & How It Works',
        description: 'Learn everything about OOPBuy Spreadsheet in 2026. Step-by-step guide, honest reviews, safety explanation, and comparison with other spreadsheet buying systems.',
        url: siteUrl,
        inLanguage: 'en-US',
        isPartOf: {
          '@type': 'WebSite',
          name: 'OOPBuy Spreadsheet Guide',
          url: siteUrl,
        },
      },
    ],
  };

  return (
    <div className="min-h-screen bg-background-50">
      <SEOHead schema={homeSchema} />
      <Navbar />

      <main>
        <HeroSection />

        <CategoryGrid
          title="Shop by"
          subtitle="Category"
          items={categories.slice(0, 3)}
          imageUrls={categoryGridAImages}
        />

        <FeatureGrid
          title="Top Picks"
          items={categories.slice(3, 6).map((c) => ({
            title: c.name,
            subtitle: `Explore ${c.name.toLowerCase()} collection`,
            linkTo: c.url,
            isExternal: true,
            externalUrl: c.url,
          }))}
          imageUrls={topPicksImages}
        />

        <AboutSEOSection />

        <CategoryGrid
          title="More"
          subtitle="Categories"
          items={categories.slice(6, 9)}
          imageUrls={categoryGridBImages}
        />

        <HowItWorksSection />

        <ComparisonSection />

        <SafetySection />

        <FeatureGrid
          title="Deep Guides"
          items={deepGuides.map((g) => ({
            title: g.title,
            subtitle: g.subtitle,
            linkTo: g.linkTo,
          }))}
          imageUrls={deepGuidesImages}
        />

        <FeaturedSnippetSection />

        <SEOArticlesGrid
          title="In-Depth SEO"
          subtitle="Guides & Resources"
          articles={seoArticles}
        />

        <TestimonialsSection />

        <FinalCTASection />
      </main>

      <Footer />
    </div>
  );
}

const deepGuides = [
  {
    title: 'How It Works',
    subtitle: 'Step-by-step breakdown of the spreadsheet shopping workflow',
    linkTo: '/oopbuy-spreadsheet-guide',
  },
  {
    title: 'Comparison Table',
    subtitle: 'OOPBuy Spreadsheet vs traditional shopping and other agents',
    linkTo: '/oopbuy-spreadsheet-guide',
  },
  {
    title: 'Safety Guide',
    subtitle: 'Everything you need to know about safe usage and best practices',
    linkTo: '/oopbuy-spreadsheet-guide',
  },
];